import { combineReducers } from "redux";
import errors from "./errors";
import usuario from "./usuario";

export default combineReducers({
    usuario,
    errors

});